module.exports = __webpack_public_path__ + "static/media/noDroneVector.88225abc.png";